import { handleActions } from 'redux-actions'

import * as aiActions from '../actions'

const defaultState = {
  AIModels: [],
  TotalCount: 0,
}

export default handleActions(
  {
    [aiActions.getUnattachedAiModels.success](state, { response }) {
      return { ...response.data }
    },
    [aiActions.resetState](state, payload) {
      return defaultState
    },
  },
  defaultState
)
